import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/sp-core/:parkingId/paystations/pay-station/:payStationId/restart/';

type MutationFnType = typeof mutationFn;

type DTO = {
    parkingId: string;
    payStationId: string;
};

const mutationFn = ({ parkingId, payStationId }: DTO): Promise<void> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, payStationId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useRestartPayStation };
